export default __webpack_public_path__ + "static/media/company1.6720168d.png";